import { createStyles } from '@mantine/core';

const useHomeStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100%',
    gap: theme.other.spacing._16,
    padding: theme.other.spacing._32,

    [theme.fn.smallerThan('lg')]: {
      padding: theme.other.spacing._24,
    },
    [theme.fn.smallerThan('md')]: {
      padding: theme.other.spacing._16,
    },
  },
}));

export default useHomeStyles;
